export default __webpack_public_path__ + "daily_dose_icon.png";